import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  TrackByFunction,
} from '@angular/core';

import { trackByProp } from '@recruitee/common';
import type { Attribute, AttributeListData } from '@recruitee/http-types';

import { IconButtonComponent } from '../../common/button/components/icon-button/icon-button.component';
import { GroupComponent } from '../../common/group/group.component';
import { IconColorDirective } from '../../common/icon/directives/icon-color.directive';
import { IconComponent } from '../../common/icon/icon.component';
import { TagComponent } from '../../common/tag/tag.component';
import { OverlayOriginDirective } from '../../core/overlay/overlay-directives';
import { AttributesComponent } from '../attributes.component';
import { TranslationsContextType } from '../attributes.types';

@Component({
  selector: 'rt-input-attributes',
  templateUrl: 'input-attributes.component.html',
  styleUrls: ['./input-attributes.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    AttributesComponent,
    GroupComponent,
    IconButtonComponent,
    IconColorDirective,
    IconComponent,
    OverlayOriginDirective,
    TagComponent,
  ],
})
export class InputAttributesComponent implements OnChanges {
  @Input() public selectedAttributes: Attribute[] = [];
  @Input() public filteredAttributes: Attribute[] = [];
  @Input() public placeholder: string;
  @Input() public hasClearButton: boolean = true;
  @Input() public noRightPadding: boolean = false;
  @Input() public disabled: boolean = false;
  @Input() public max: number | null = null;
  @Input() public translationsContext: TranslationsContextType;

  @Output() public save: EventEmitter<Attribute> = new EventEmitter();
  @Output() public query: EventEmitter<string> = new EventEmitter();
  @Output() public deleteAttribute: EventEmitter<Attribute> = new EventEmitter();
  @Output() public clearAll: EventEmitter<void> = new EventEmitter();

  public toggle: boolean = false;
  public trackById: TrackByFunction<Attribute> = trackByProp<Attribute>({ prop: 'id' });
  public suggestionsData: AttributeListData = { isLoading: false, meta: null, rows: [] };

  constructor(protected cdRef: ChangeDetectorRef) {}

  public ngOnChanges(changes: SimpleChanges): void {
    if ('filteredAttributes' in changes) {
      this.suggestionsData = {
        meta: {
          page: 1,
          limit: this.filteredAttributes.length,
          totalCount: this.filteredAttributes.length,
        },
        rows: this.filteredAttributes,
        isLoading: false,
      };
    }
  }

  public onSave(attr: Attribute): void {
    if (this.max === null || this.max > this.selectedAttributes.length) {
      this.save.emit(attr);
    }

    this.toggle = !this.toggle;
    this.cdRef.detectChanges();
  }

  public handleClearAll(event: MouseEvent): void {
    event.stopPropagation();
    if (!this.disabled) {
      this.clearAll.emit();
    }
  }
}
